import { signal } from '@angular/core';
import { TwcLegendParams } from '../../../twc-legend/twc-legend.params';
import { TwcLegendComponent } from '../../../twc-legend/twc-legend.component';
import { MetarsSvgComponent } from './metars-svg/metars-legend-svg';

export const METARS_LEGEND: TwcLegendParams = {
  title: 'METARS',
  legendTitleBarInfo: signal('0'),
  data: { svgComponent: MetarsSvgComponent },
  legendComponent: TwcLegendComponent
};
